import { uploadGolfImages } from '@/api/index';

const getDefaultState = () => {
  return { /* = data */
    step: 1,
    setupData: {
      course: {},
      sensors: [],
      stations: [],
      users: [],
    },
    logo: null,
    backgroundImgs: null,
    
    userSelected: null,
    editingUser: false,
    stationSelected: null,
    editingStation: false,

    loading: {
      course: false,
      sensorsStored: false,
      sensorsAvailable: false,
      savingSensors: false,
      deletingSensors: false,
      btnContinue: false,
      updatingCourse: false,
      deletingCourse: false,
      stations: false,
      savingStation: false,
      users: false,
    },
    canBack: async () => true,
    canContinue: async () => true,
    showNewUserPage: false,
    showNewStationPage: false,
  };
}

export default {
  namespaced: true,
  state: getDefaultState(),

  getters: { /* = Computed properties, perfects to filter data an execute some calculation */
  },


  actions: { /* = Methods */

    async uploadCourseImages({ state, dispatch }, courseId) {
      if (state.backgroundImgs && state.backgroundImgs.length) {
        for (let image of state.backgroundImgs) {
          await dispatch('uploadCourseImage', {courseId, type: 'background', image});
        }
      }

      if (state.logo && state.logo.file) {
        const course = await dispatch('uploadCourseImage', {courseId, type: 'logo', image: state.logo});
        return course;
      }
    },

    async uploadCourseImage({ commit }, {courseId, type, image}) {
      const formData = new FormData();
      formData.append(type, image.file, image.name);
      return await uploadGolfImages(courseId, formData, type);
    },

  },

  mutations: { /* Mutations are responsible to change the state */
    
    setSetupData(state, data) {
      state.setupData = { ...state.setupData, ...data };
    },

    addUser(state, user) {
      state.setupData = { ...state.setupData, users: [...state.setupData.users, user]  };
    },

    updateUser(state, user) {
      state.setupData = { ...state.setupData, 
                          users: [
                                  ...state.setupData.users.filter(u => user.user_id ? u.user_id !== user.user_id : u.username !== user.username),
                                  user
                                ]  };
    },

    deleteUser(state, index) {
      state.setupData.users.splice(index, 1);
    },

    addStation(state, station) {
      state.setupData = { ...state.setupData, stations: [...state.setupData.stations, station]  };
    },

    updateStation(state, station) {
      state.setupData = { ...state.setupData, 
                      stations: [
                                  ...state.setupData.stations.filter(u => station.station_id ? u.station_id !== station.station_id : u.device_sn !== station.device_sn),
                                  station
                                ]  };
    },

    deleteStation(state, index) {
      state.setupData.stations.splice(index, 1);
    },

    setLogo(state, logo) {
      state.logo = logo;
    },

    setBackgroundImgs(state, backgroundImgs) {
      state.backgroundImgs = backgroundImgs;
    },

    setShowNewUserPage(state, show) {
      state.showNewUserPage = show;
    },

    setShowNewStationPage(state, show) {
      state.showNewStationPage = show;
    },

    setStep(state, step) {
      state.step = step;
    },

    setLoading(state, loading) {
      state.loading = { ...state.loading, ...loading };
    },
    
    setCanBack(state, canBack) {
      // eslint-disable-next-line
      state.canBack = canBack ? canBack : (async () => true);
    },

    setCanContinue(state, canContinue) {
      // eslint-disable-next-line
      state.canContinue = canContinue ? canContinue : (async () => true);
    },

    setUserSelected(state, user) {
      state.userSelected = user;
    },

    setEditingUser(state, editingUser) {
      state.editingUser = editingUser;
    },

    setStationSelected(state, station) {
      state.stationSelected = station;
    },

    setEditingStation(state, editingStation) {
      state.editingStation = editingStation;
    },

    resetStore(state) {
      Object.assign(state, getDefaultState())
    },

  },

};
